<template>
	<pre v-html="$t('terms.agreement3')"></pre>
</template>

<script>
export default {
	name: 'Agreement3',
};
</script>

<style scoped></style>
